<template>
  <div class="transmission-base-detail">
    <div class="banner-info">
      <img src="../../../assets/img/banner.png" class="banner" />
      <div class="text">
        <p>张铁山</p>
        <p>陕西测试工坊地址三门前75号</p>
        <p>陕西铁山内画研究院</p>
      </div>
      <div class="content">
        <h5>陕西铁山内画研究院</h5>
        <p>
          陕西铁山内画研究院是陕西省文化厅命名的“陕西省文化产业示范单位”，先后培养了数十名省级工艺美术大师、专业内画技师，内画作品受到同行业界与政府以及学术界的关注与肯定，在国内外多次获奖，部分作品被收藏界珍藏，是陕西工艺美术界极具产业规模的文化艺术力量。
        </p>
        <div class="star-box">
          <img :src="star" v-for="item of 5" :key="item" />
        </div>
      </div>
    </div>
    <div class="workshop-wrapper">
      <div class="workshop">
        <h4>工作环境</h4>
        <div class="box-list">
          <div class="box" v-for="item in 4" :key="item">
            <img src="../../../assets/img/d1.jpg" alt="" />
            <p>内画制作</p>
          </div>
        </div>
      </div>
    </div>
    <div class="experts">
      <h4>专家介绍</h4>
      <div class="experts-list">
        <div class="box-l">
          <img src="../../../assets/img/d4.jpg" alt="" />
          <div class="mask"></div>
        </div>
        <div class="box-r">
          <div class="name">张铁山</div>
          <div class="text">
            <span>国家工艺美术大师</span>
            <span>行业分类：内壁画</span>
          </div>
          <p>
            美术泛指创作占有一定平面或空间，且具有可视性的艺术。它的划分有多种，一般包括四大门类绘画、雕塑、设计、建筑。现代有些学者也把其它的归纳入这个门类，例如书法、摄影等。“美术”这一名词始见于欧洲17世纪，也有人认为正式出现于18世纪中叶
          </p>
        </div>
      </div>
    </div>
    <div class="instructor">
      <h5>指导老师</h5>
      <div class="wrap">
        <task-show></task-show>
      </div>
    </div>
    <div class="workshop-course">
      <h5>工坊课程</h5>
      <div
        class="box"
        v-for="(item, index) in 2"
        :key="item"
        :class="{ order: index === 1 }"
      >
        <img src="../../../assets/img/video-cover.png" alt="" />
        <div class="desc">
          <div class="title">
            <h6>《中国漆画艺术-初级》</h6>
            <span>讲师：张铁山｜国家工美大师 </span>
          </div>
          <p>
            漆画以天然大漆为主要材料的绘画，除漆之外，还有金、银、铅、锡以及蛋壳、贝壳、石片、木片等。它既是艺术品，又是实用装饰品，成为壁饰、屏风和壁画等的表现形式。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TaskShow from "@/components/TaskShow";
export default {
  name: "Detail",
  components: {
    TaskShow,
  },
  data() {
    return {
      star: require("@/assets/img/star.png"),
      starGray: require("@/assets/img/star.png"),
    };
  },
};
</script>

<style lang="scss">
.transmission-base-detail {
  .banner-info {
    position: relative;
    .banner {
      width: 100%;
      height: 569px;
    }
    .text {
      padding-top: 64px;
      width: 1240px;
      height: 276px;
      margin: 0 auto;
      p {
        margin-bottom: 15px;
        line-height: 15px;
        font-size: 15px;
        color: #333;
        text-indent: 22px;
      }
      p:nth-of-type(1) {
        background: url("../../../assets/img/name.png") no-repeat;
        background-size: 15px 15px;
      }
      p:nth-of-type(2) {
        background: url("../../../assets/img/address.png") no-repeat;
        background-size: 15px 15px;
      }
      p:nth-of-type(3) {
        background: url("../../../assets/img/school.png") no-repeat;
        background-size: 15px 15px;
      }
    }
    .content {
      width: 48.8vw;
      // height: 296px;
      padding: 48px 80px 0 50px;
      background-color: #2d3f51;
      position: absolute;
      right: 13.9vw;
      bottom: 100px;
      h5 {
        color: #fff;
        font-size: 26px;
        line-height: 92px;
        margin-bottom: 0;
      }
      p {
        line-height: 30px;
        color: #fff;
        font-size: 15px;
        margin-bottom: 10px;
      }
      .star-box {
        text-align: right;
        margin-bottom: 35px;
        img {
          width: 22px;
          height: 22px;
          margin-right: 10px;
        }
      }
    }
  }
  .workshop-wrapper {
    background-color: #f5f5f5;
  }
  .workshop {
    width: 1240px;
    height: 465px;
    margin: 0 auto;
    text-align: center;
    h4 {
      margin: 0;
      padding: 43px 0 66px;
      line-height: 20px;
      font-size: 20px;
      color: #333;
    }
    .box-list {
      display: flex;
      justify-content: space-between;
      .box {
        overflow: hidden;
        border-radius: 9px;
        box-shadow: 5px 5px 5px rgb(0 0 0 / 7%);
        img {
          width: 290px;
          height: 186px;
        }
        p {
          line-height: 60px;
          font-size: 15px;
          color: #333;
          margin: 0;
          background-color: #fff;
        }
      }
    }
  }
  .experts {
    h4 {
      margin: 62px 0 94px;
      line-height: 20px;
      font-size: 20px;
      color: #333;
      text-align: center;
    }
    .experts-list {
      display: flex;
      justify-content: space-between;
      height: 564px;
      .box-l {
        width: 46.7vw;
        height: 23.43vw;
        min-width: 598px;
        min-height: 300px;
        position: relative;
        img {
          width: 46.7vw;
          height: 23.43vw;
          min-width: 598px;
          min-height: 300px;
        }
        .mask {
          width: 13.85vw;
          height: 3.9vw;
          min-width: 178px;
          height: 50px;
          background-color: rgba(45, 63, 81, 0.69);
          position: absolute;
          right: -5.2vw;
          bottom: -1.2vw;
        }
      }
      .box-r {
        width: 48vw;
        min-width: 614px;
        min-height: 564px;
        padding: 4.64vw 0 0 0.94vw;
        .name {
          font-size: 15px;
          color: #333;
        }
        .text {
          padding: 0.52vw 0 4.89vw;
          font-size: 13px;
          color: #aaa;
          span {
            margin-right: 34px;
          }
        }
        p {
          width: 33.64vw;
          min-width: 440px;
          line-height: 22px;
          font-size: 14px;
          color: #333;
          margin: 0;
        }
      }
    }
  }
  .instructor {
    padding-bottom: 48px;
    background-color: #f5f5f5;
    h5 {
      margin: 0;
      padding: 41px 0 90px;
      font-size: 20px;
      color: #333;
      text-align: center;
    }
    .wrap {
      width: 1240px;
      margin: 0 auto;
    }
  }
  .workshop-course {
    width: 1240px;
    margin: 0 auto;
    h5 {
      margin: 0;
      padding: 67px 0 76px;
      line-height: 20px;
      font-size: 20px;
      color: #333;
      text-align: center;
    }
    .box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 55px;
      img {
        width: 566px;
        height: 318px;
      }
      .desc {
        padding-top: 95px;
        width: 620px;
        .title {
          display: flex;
          justify-content: left;
          line-height: 67px;
          h6 {
            margin: 0 20px 0 0;
            font-size: 20px;
            color: #333;
          }
          span {
            font-size: 15px;
            color: #7f7f7f;
          }
        }
      }
      p {
        line-height: 21px;
        font-size: 15px;
        color: #333;
        margin: 0;
      }
    }
    .order {
      img {
        order: 2;
      }
      .desc {
        order: 1;
      }
    }
  }
}
</style>